import { render, staticRenderFns } from "./governmentalService.vue?vue&type=template&id=7e472afe&scoped=true"
import script from "./governmentalService.vue?vue&type=script&lang=js"
export * from "./governmentalService.vue?vue&type=script&lang=js"
import style0 from "./governmentalService.vue?vue&type=style&index=0&id=7e472afe&prod&lang=less&scoped=true"
import style1 from "./governmentalService.vue?vue&type=style&index=1&id=7e472afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e472afe",
  null
  
)

export default component.exports